import { Component, input, output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

export type BannerVariant = 'offline' | 'info';

@Component({
  selector: 'mbm-banner',
  imports: [TranslateModule],
  templateUrl: './mbm-banner.component.html',
  styleUrl: './mbm-banner.component.scss',
})
export class MbmBannerComponent {
  readonly variant = input<BannerVariant>('info');
  readonly messageKey = input.required<string>();
  readonly actionTextKey = input<string>();
  readonly actionClick = output<void>();
}
